module.exports = __webpack_public_path__ + "img/onlyMobile.e70595f5.png";